/**
 * Settings Page
 */

export default function SettingsPage() {
  return (
    <div className="px-6 pt-8 pb-12">
      <h1 className="text-xl font-medium text-[#101828] mb-2">Settings</h1>
      <p className="text-base text-[#4a5565] mb-8">
        Manage your account and preferences
      </p>
      
      <div className="bg-white border border-gray-200 rounded-[14px] p-6">
        <p className="text-gray-600">Settings page coming soon...</p>
      </div>
    </div>
  )
}












